import React from "react";
import { Layout, LAGToken } from "../components";

const LAGTokenPage = () => {
  return (
    <>
      <Layout>
        <LAGToken />
      </Layout>
    </>
  );
};

export default LAGTokenPage;
